var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',[(_vm.useWebp)?_c('client-only',[_c('source',{attrs:{"srcset":_vm.webpImageUrl,"type":"image/webp"}}),_vm._v(" "),_c('source',{attrs:{"srcset":_vm.baseImageUrl,"type":_vm.srcMime}})]):_vm._e(),_vm._v(" "),_c('img',{class:_vm.classes,style:(_vm.styles),attrs:{"src":_vm.baseImageUrl,"alt":_vm.alt,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }